<div *ngIf="breFailure">
  <wl-card>
    <br><br><br><br>
    <h3 class="text-center">The customer profile has failed on BRE level.</h3>
    <br><br><br><br>
  </wl-card>
</div>

<wl-card heading="Loan Renewal Application" *ngIf="!datanotverified && !breFailure && !showOverallCard">
  <div [ngStyle]="pointerStyle">

    <form novalidate [formGroup]="loanRenewalForm">
      <wl-card heading="Borrower Details">
        <wl-input type="text" label="Name of the Borrower" formControlName="name_of_borrower" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Name of the Co-Applicant" formControlName="name_of_co_applicant" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Customer ID" formControlName="customer_id" [readonly]="true" disabled></wl-input>
        <wl-input type="text" label="Account Number" formControlName="bank_acc_no" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Enter Correspondence Address" formControlName="corps_address" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Mobile Number" formControlName="mobile_number" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Aadhaar Number" formControlName="aadhaar_number" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Date of Birth" formControlName="dob_borrower" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Credit Facility Since" formControlName="credit_facility_since" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Purpose of Advance" formControlName="purpose_of_adv" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Type of Farmer" formControlName="type_of_farmer" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Asset Classification" formControlName="assest_classification" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Category, if Applicable" formControlName="category_if_applicable" [readonly]="true"
          disabled></wl-input>


        <wl-progress [hidden]="isDataPending"></wl-progress>

      </wl-card>

      <wl-card heading="1. Purpose of the note:  Renewal of KCC(UGC) at existing level">
        <wl-input type="text" label="Date of Sanction" formControlName="date_of_sanction" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Last Renewal Date" formControlName="last_renewal_date" [readonly]="true"
          disabled></wl-input>
        <wl-input type="text" label="Due Date of Review" formControlName="due_date_of_review" [readonly]="true"
          disabled></wl-input>
        <div child-container class="table-responsive table-bordered">
          <p class="text-left">Report Date: {{reportdate}}</p>
          <h3 class="text-left">CIC Score of Borrower and Co-Applicant if Applicable</h3>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Sr No.</th>
                <th class="text-center">Name of Farmer</th>
                <th class="text-center">Score</th>
              </tr>
            </thead>
            <tbody>

              <tr class="h-20px">
                <td class="text-center">1

                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" formControlName="name_of_borrower2" [readonly]="true"
                    disabled>
                  </wl-input>
                </td>
                <td class="text-center">
                  <wl-input-nolabel type="text" class="w-full" [(ngModel)]="score"
                    formControlName="crif_score_data" [readonly]="true" disabled>
                  </wl-input-nolabel>
                </td>
              </tr>
              <tr class="h-20px" *ngIf="crif_score_coappflag">
                <td class="text-center">2

                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" formControlName="name_of_coapp" [readonly]="true"
                    disabled></wl-input>
                </td>
                <td class="text-center">
                  <wl-input-nolabel type="text" class="w-full" formControlName="crif_score_coapp" [readonly]="true"
                    disabled>
                  </wl-input-nolabel>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </wl-card>




      <wl-card heading="2. Land Details and Cropping Pattern:">
        <h3>Land details</h3>
        <!-- KA -->
        <div child-container class="table-responsive table-bordered" *ngIf="!isMP && !isAP">
          <h3 class="text-center">(as per Branch Record)</h3>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Sub Survey No</th>
                <th class="text-center">Survey No</th>
                <th class="text-center">Village</th>
                <th class="text-center">Hobli</th>
                <th class="text-center">Taluk</th>
                <th class="text-center">District</th>
                <th class="text-center">Land Area</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of bhoomi_files">

                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.sub_survey_no}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.survey_no}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.village}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.hobli}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.taluk}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.district}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.land_area}}
                </td>

                <!-- fruits land record  -->
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.Hissano}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.Surveyno}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.VillageName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.HobliName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.TalukName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.DistrictName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Landdata[0]?.ExtAcre + file?.bhoomi_details.Landdata[0]?.ExtGunta*0.025}}
                </td>
              </tr>


            </tbody>
          </table>
          <p class="text-center">*Regarding any changes to be made to the cropping pattern, edit them in the
            Online Consent Form and re-submit the form.</p>
        </div>
        <div child-container class="table-responsive table-bordered" *ngIf="!isMP && !isAP">
          <h3 class="text-center">(Land Records from Bhoomi Portal)</h3>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Sub Survey No</th>
                <th class="text-center">Survey No</th>
                <th class="text-center">Village</th>
                <th class="text-center">Hobli</th>
                <th class="text-center">Taluk</th>
                <th class="text-center">District</th>
                <th class="text-center">Land Area</th>
                <th class="text-center">Charge Details</th>
                <th class="text-center">Land Ownership</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of bhoomi_files">
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.sub_survey_no}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.survey_no}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.village}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.hobli}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.taluk}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  {{file?.land_details?.district}}
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  <span *ngIf="file.bhoomi_details">
                    {{file?.bhoomi_details?.land_area}}
                  </span>
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  <span *ngIf="file.bhoomi_details">
                    {{file.bhoomi_details.charge_details}}
                  </span>
                </td>
                <td *ngIf="!file.bhoomi_details" class="text-center">
                  <span *ngIf="file.bhoomi_details">
                    {{file.bhoomi_details.name_as_per_bhumi}}
                  </span>
                </td>

                <!-- fruits land record  -->
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Hissano}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.Surveyno}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.VillageName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.HobliName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.TalukName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.DistrictName}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  {{file?.bhoomi_details?.ExtAcre+file?.bhoomi_details?.ExtGunta*0.025}}
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  <span *ngIf="file.bhoomi_details">
                    {{file?.bhoomi_details?.charge_details}}
                  </span>
                </td>
                <td *ngIf="file.bhoomi_details" class="text-center">
                  <span *ngIf="file.bhoomi_details">
                    {{file?.bhoomi_details?.name_as_per_bhumi}}
                  </span>
                </td>
              </tr>
              
            </tbody>
          </table>
        </div>

      <!-- AP -->
      <div child-container class="table-responsive table-bordered" *ngIf="isAP">
        <h3 class="text-center">(as per Branch Record)</h3>
        <table class="table table-hover">
          <thead>
            <tr>
              <th class="text-center">Survey No</th>
              <th class="text-center">Village</th>
              <th class="text-center">Mandal</th>
              <th class="text-center">District</th>
              <th class="text-center">Land Area</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of bhoomi_files">
              <td  class="text-center">
                {{file?.landParcelDetails[0]?.SurveyNo}}
              </td>
              <td  class="text-center">
                {{file?.input?.village_eng}}
              </td>
              <td  class="text-center">
                {{file?.input?.mandal_eng}}
              </td>
              <td class="text-center">
                {{file?.input?.district_eng}}
              </td>
              <td  class="text-center">
                {{file?.landParcelDetails[0]?.Total_Extent}}
              </td>
          </tbody>
        </table>
        <p class="text-center">*Regarding any changes to be made to the cropping pattern, edit them in the Online Consent Form and re-submit the form.</p>
      </div>
      <div child-container class="table-responsive table-bordered" *ngIf="isAP">
        <h3 class="text-center">(Land Records from Mee Bhoomi Portal)</h3>
        <table class="table table-hover">
          <thead>
            <tr>
              <th class="text-center">Survey No</th>
              <th class="text-center">Village</th>
              <th class="text-center">Mandal</th>
              <th class="text-center">District</th>
              <th class="text-center">Land Area</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of bhoomi_files">
              <td class="text-center">
                {{file?.landParcelDetails[0]?.SurveyNo}}
              </td>
              <td class="text-center">
                {{file?.input?.village_eng}}
              </td>
              <td  class="text-center">
                {{file?.input?.mandal_eng}}
              </td>
              <td class="text-center">
                {{file?.input?.district_eng}}
              </td>
              <td class="text-center">
                {{file?.landParcelDetails[0]?.Total_Extent}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
               


      <!-- MP -->
        <!-- MP -->

        <div child-container class="table-responsive table-bordered" *ngIf="isMP">
          <h3 class="text-center">(as per Branch Record)</h3>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Khasra No.</th>
                <th class="text-center">Village</th>
                <th class="text-center">Tehsil</th>
                <th class="text-center">District</th>
                <th class="text-center">Land Area</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of bhoomi_files">
                <td class="text-center">
                  {{file
                     && file.land_details 
                     && file.land_details.landParcelDetails 
                     && file?.land_details?.landParcelDetails[0]
                      && file?.land_details?.landParcelDetails[0]?.surveyNo 
                      && file?.land_details?.landParcelDetails[0]?.surveyNo[0]?file?.land_details?.landParcelDetails[0]?.surveyNo[0]:"-"}}
                </td>
                <td class="text-center">
                  {{file?.village_eng}}
                </td>
                <td class="text-center">
                  {{file?.taluk_eng}}
                </td>
                <td class="text-center">
                  {{file?.district_eng}}
                </td>
                <td class="text-center">
                  {{file
                    && file.land_details 
                    && file.land_details.landParcelDetails 
                    && file?.land_details?.landParcelDetails[0]
                     && file?.land_details?.landParcelDetails[0].surveyNoArea 
                     && file?.land_details?.landParcelDetails[0]?.surveyNoArea[0] &&
                    file?.land_details?.landParcelDetails[0]?.surveyNoArea[0]?file?.land_details?.landParcelDetails[0]?.surveyNoArea[0]:"-"}}
                </td>
              </tr>


            </tbody>
          </table>
          <p class="text-center">*Regarding any changes to be made to the cropping pattern, edit them in the
            Online Consent Form and re-submit the form.</p>
        </div>
        <div child-container class="table-responsive table-bordered" *ngIf="isMP">
          <h3 class="text-center">(Land Records from Bhoomi Portal)</h3>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Khasra No.</th>
                <th class="text-center">Village</th>
                <th class="text-center">Tehsil</th>
                <th class="text-center">District</th>
                <th class="text-center">Land Area</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of bhoomi_files">
                <td class="text-center">
                  {{file
                    && file.land_details 
                    && file.land_details.landParcelDetails 
                    && file?.land_details?.landParcelDetails[0]
                     && file?.land_details?.landParcelDetails[0]?.surveyNo 
                     && file?.land_details?.landParcelDetails[0]?.surveyNo[0]?file?.land_details?.landParcelDetails[0]?.surveyNo[0]:"-"}}
                </td>
                <td class="text-center">
                  {{file?.village_eng}}
                </td>
                <td class="text-center">
                  {{file?.taluk_eng}}
                </td>
                <td class="text-center">
                  {{file?.district_eng}}
                </td>
                <td class="text-center">
                  {{file
                    && file.land_details 
                    && file.land_details.landParcelDetails 
                    && file?.land_details?.landParcelDetails[0]
                     && file?.land_details?.landParcelDetails[0].surveyNoArea 
                     && file?.land_details?.landParcelDetails[0]?.surveyNoArea[0] &&
                    file?.land_details?.landParcelDetails[0]?.surveyNoArea[0]?file?.land_details?.landParcelDetails[0]?.surveyNoArea[0]:"-"}}
                </td>
              </tr>


            </tbody>
          </table>
        </div>

        <br>

        <h3>Cropping Pattern as per given by the Farmer</h3>
        <table class="table table-hover ">

          <thead>
            <tr>
              <th class="text-center">Sr. No.</th>
              <th class="text-center">Cropping season</th>
              <th class="text-center">Name of the Crop - List </th>
              <th class="text-center">Crop Area - in {{acreOrHectare}}s
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let cropdata of cropping_pattern_data1;let i= index;">
              <td class="text-center">
                {{i+1}}
              </td>
              <td class="text-center">
                {{cropdata.crop_season && cropdata.crop_season=='kharif'?"Kharif":cropdata.crop_season}}
              </td>
              <td class="text-center">
                {{cropdata.crop_name?cropdata.crop_name:""}}
              </td>
              <td class="text-center">
                {{cropdata.area?cropdata.area:""}}
              </td>
            </tr>
          </tbody>
        </table>
      </wl-card>

      <wl-card heading="3. Assessment of Limit (UGC):">
        <div child-container class="table-responsive">
          <form novalidate [formGroup]="cropDataForm">
            <div formArrayName="cropArray">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="w-15px text-center">Sr. No.</th>
                    <th class="text-center">Cropping season</th>
                    <th class="text-center">Crop Proposed
                      (A)
                    </th>
                    <th class="text-center">Area of cultivation (In {{acreOrHectare}}s)
                      (B)
                    </th>
                    <th class="text-center">Scale of Finance (per {{acreOrHectare}}s)
                      (C)
                    </th>
                    <th class="text-center">Total Cost of Cultivation (Rs)
                      (D)= (B*C)
                    </th>
                    <th class="text-center">Additional SOF (%) (ASOF) over and above D, as permitted by RO
                      (E)
                    </th>
                    <th class="text-center">Additional SOF % Amount<br>
                      (F )= [D+E]
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let cropArray of cropArray().controls; let i=index;" [formGroupName]="i">
                    <td class="text-center vertical-align-middle">
                      {{i+1}}
                    </td>
                    <td class="text-center vertical-align-middle w-5vw">
                      <wl-input-nolabel type="text" placeholder="" formControlName="crop_season" [readonly]="true"
                        disabled>
                      </wl-input-nolabel>

                    </td>
                    <td class="text-center vertical-align-middle w-5vw">
                      <wl-input-nolabel type="text" placeholder="" formControlName="crop_name" [readonly]="true"
                        disabled>
                      </wl-input-nolabel>
                    </td>
                    <td class="text-center vertical-align-middle w-5vw">
                      <wl-input-nolabel type="text" placeholder="" formControlName="area" [readonly]="true" disabled>
                      </wl-input-nolabel>
                    </td>
                    <td class="text-center vertical-align-middle w-5vw">
                      <wl-input-nolabel type="text" placeholder="" formControlName="scal_of_fin" [readonly]="true"
                        disabled>
                      </wl-input-nolabel>

                    </td>
                    <td class="text-center vertical-align-middle w-5vw">
                      <wl-input-nolabel type="text" placeholder="" formControlName="loan_amount" [readonly]="true"
                        disabled>
                      </wl-input-nolabel>

                    </td>
                    <td class="text-center w-5vw">
                      <div [ngClass]="{'lineAdding': isAddcustomClass, '': !isAddcustomClass}"></div>
                      <wl-input-nolabel placeholder="" formControlName="add_sof_percent"
                        [readonly]="true"
                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></wl-input-nolabel>
                      <span *ngIf="getValidity(i)" class="text-red font-size-10px">
                        Please enter a value<br> between 0% and 100%
                      </span>
                    </td>
                    <td class="text-center w-5vw">
                      <wl-input-nolabel type="text" placeholder="" formControlName="add_sof_amt" [readonly]="true"
                        disabled>
                      </wl-input-nolabel>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </form>

          <table>
            <tr>

              <!-- placeholder="(4)"  -->
              <td><label>Crop Insurance Amount (In case customer has OPT IN Consent letter and insurance applicable for
                  crop)</label></td>
              <td>
                <wl-input type="number" label="" formControlName="crop_insurance_amount" [readonly]="true"
                  disabled></wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Total Limit (G)</label></td>

              <!-- Sum Total (E) = (1+2+3+4) -->
              <td>
                <wl-input type="number" label="" placeholder="" formControlName="total_limit" [readonly]="true"
                  disabled>
                </wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Add: 10% Limit for Post Harvest/Household/Consuption</label></td>

              <!-- F = 10% of (E) -->
              <td>
                <wl-input type="number" label="" placeholder="" formControlName="ten_per_limit_post_harvest"
                  [readonly]="true" disabled>
                </wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Add: 20% Limit towards Maintenance Expenses of Farm Assets</label></td>

              <!-- G = 20% of (E) -->
              <td>
                <wl-input type="number" label="" placeholder="" formControlName="twenty_per_limit_maint_expenses"
                  [readonly]="true" disabled>
                </wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Gross Assessed Limit (J)</label></td>

              <!-- H = E+F+G -->
              <td>
                <wl-input type="number" label="" placeholder="" [(ngModel)]="gross_assessed_limit"
                  formControlName="gross_assessed_limit" [readonly]="true" disabled></wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Additional SOF Total Amount (F)</label></td>
              <!-- F = 10% of (E) -->
              <td>
                <wl-input type="number" label="" placeholder="" [(ngModel)]="proposed_sof_ro"
                  formControlName="proposed_sof_ro" [readonly]="true" disabled></wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Final Assessed Limit (K)</label></td>
              <!-- F = 10% of (E) -->
              <td>
                <wl-input type="number" label="" placeholder="" [(ngModel)]="final_assed_limit"
                  formControlName="final_assed_limit" [readonly]="true" disabled></wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Sanction Limit (L)</label></td>

              <!-- As per Finacle -->
              <td>
                <wl-input type="number" label="" placeholder="" formControlName="sanction_limit" [readonly]='true'
                  disabled>
                </wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Existing Drawing Power (DP) (M)</label></td>

              <!-- As per Finacle -->
              <td>
                <wl-input type="number" label="" placeholder="" formControlName="existing_drawing_power"
                  [readonly]='true' disabled></wl-input>
              </td>
            </tr>
            <tr>
              <td><label>Proposed DP (M)</label></td>

              <td>
                <wl-input type="number" label="" [(ngModel)]="proposed_dp_k" formControlName="proposed_dp_k"
                  [readonly]='true' disabled></wl-input>
              </td>
            </tr>
          </table>

        </div>
      </wl-card>


      <wl-card heading="4. RECOMMENDATIONS ">
        <div child-container class="table-responsive table-bordered">
          <span>We Recommend for renewal of KCC (Union Green Card-UGC) facilities as mentioned below on stated terms and
            conditions:</span>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nature of Limit</th>
                <th colspan="4">Amount (Rs. in lakhs)</th>
                <th class="text-center">ROI(%)</th>
                <th class="text-center">Security
                </th>
              </tr>
              <tr>
                <th>CCAGR</th>
                <th>Sanction Limit</th>
                <th>Existing DP</th>
                <th>Outstanding <br> Balance as on</th>
                <th>Proposed DP</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">
                  KCC (Union Green Card-UGC)
                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" placeholder="" formControlName="sanction_limit_j"
                    [readonly]='true' disabled>
                  </wl-input>
                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" placeholder="" formControlName="existing_dp_apf"
                    [readonly]='true' disabled></wl-input>
                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" placeholder="" formControlName="outstanding_as_on"
                    [readonly]='true' disabled></wl-input>
                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" placeholder="" [(ngModel)]="proposed_dp_k"
                    formControlName="proposed_dp_k" [readonly]='true' disabled>
                  </wl-input>
                </td>
                <td class="text-center">
                  <wl-input type="text" class="w-full" placeholder="" formControlName="roi_apf" [readonly]='true'
                    disabled>
                  </wl-input>
                </td>
                <td class="text-center">Hypothecation of Standing Crops and other Securities as per existing
                  terms
                  of sanction.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>Terms and conditions: The renewal of KCC (Union Green Card-UGC) is subject to the following:</h3>
        <p class="font-size-15px">1. All terms & conditions as stipulated in existing sanction to continue and branch
          to
          ensure
          compliance.<br>

          2. Branch to ensure rectification of all pending audit irregularities (if any) within a period of 30 days
          from the date of renewal.<br>

          3. Branch to ensure obtention of DBC within 15 days from the date of renewal of limit and same is to
          be updated in Finacle.<br>

          4. Standing Crops (Primary Security) to be insured (where ever applicable) in line with the extended
          guidelines<br>

          5. Branch to conduct inspection of the field within a period of 30 days from the date of renewal of KCC
          (Union Green Card-UGC) and ensure its satisfactory readings. Apart from the above, Branch to carry out
          periodic inspection of securities/field regularly as per extant bank guidelines.<br>

          6. Branch to ensure that the security documents are valid & in force.<br>

          7. Branch to ensure that charges of any other lender is not marked over the land against which UGC has been
          sanctioned.<br>

          8. Branch to ensure that our charges for primary Security is noted on the land records.<br>

          9. Short term production loans are eligible for Interest subvention/ incentive for prompt repayment as
          advised by GOI and / or State Governments from time to time.<br>

          10. Name of the borrower and particulars of the credit facilities will be disclosed to CIBIL / Public in
          case of default, as per the guidelines of Bank and RBI.<br>

          11. Rate of Interest and margins stipulated are subject to changes made from time to time at sole discretion
          of the Bank.<br>

          12. The credit limit shall be renewed within 12 months from the date of this renewal.</p>
      </wl-card>

      <wl-card heading="CBS Auto-Renewal Status">
        <wl-input type="text" label="Status" class="w-full" formControlName="cbs_status" [readonly]="true"
          disabled>
        </wl-input>
      </wl-card>

      <div class="col-md-4,col-lg-4" *ngIf="maker_checker_flag && checker_flag">
        <br>
        <wl-list *ngIf="annexure_form_status" [disabled]="maker_checker_submitflag" id="id" label="Consent For Renewal"
          placeholder="Select Status" [(ngModel)]="approval_status" [options]="annexure_form_status.value"
          (ngModelChange)="approval_stfn($event)" formControlName="approval_status"></wl-list>
      </div>
      <div class="container" *ngIf="comments_flag">
        <div class="row">
          <div class="col-12 col-md-4 pt-10px-important">
            <label>Remarks</label>
          </div>
          <div class="col-12 col-md-5 w-full-important">
            <br>
            <textarea formControlName="comments" [disabled]="maker_checker_submitflag" class="w-full-important"
              [(ngModel)]="comments" rows="8" col="6"></textarea>
          </div>
        </div>
      </div>

      <div class="text-center" *ngIf="!disableEverything">
        <br>


      </div>

    </form>
  </div>
  <br>

  <br>
  <div class="text-center">
    <button class="mybutton" *ngIf="!reportLink && !isReportPending" [disabled]="hideButton" (click)="generateReport()">Generate Loan Renewal
      Application Form</button>
    <div class="text-center-important">
      <mat-progress-spinner *ngIf="isReportPending" class="spinner-custom" mode="indeterminate">
      </mat-progress-spinner>
    </div>
    <button *ngIf="reportLink" (click)="downloadPdf()" class="h-18px mybutton" target="_blank">Download
      Loan Renewal Application Form</button>
  </div>
  <br><br><br>



</wl-card>



<wl-card heading="Loan Renewal Form - Annexure III" *ngIf="datanotverified && !breFailure">
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 id="ConsentText" class="text-center">{{datamessage}}</h3>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
</wl-card>

<wl-card heading="Loan Renewal Form - Annexure III" *ngIf="!breFailure && showOverallCard && !datanotverified">
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 id="ConsentText" class="text-center">{{overAllStatusMessageToDisplay}}</h3>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
</wl-card>

